import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import * as Styled from '../OrderView.style';
import { getOrderTaskStatusFriendlyName } from '../utils/orderTask';

const LOCALIZED_TEXT = {
  totalRefund: 'orderView.charges.totalRefund',
  partialRefund: 'orderView.charges.partialRefund',
  coupon: 'orderView.charges.coupon',
};

const ChargesRow = ({
  loading,
  isRefund,
  parentTransaction,
  isDiscount,
  transaction: { amount, orderItemUuid: itemUuid, transactionDatetime, description } = {},
  orderTasks,
  parentOrderTask,
}) => {
  const { formatMessage: fm } = useIntl();
  const orderTransaction = orderTasks.find(({ orderItemUuid }) => orderItemUuid === itemUuid);
  const parts = description?.split(' × ');
  let splitDescription = parts?.length > 1 ? parts[1]?.split('(')?.[0]?.trim() : description;

  splitDescription = splitDescription?.replace(/_/g, ' ');

  let status;
  if (isRefund) {
    status =
      parentTransaction?.amount === amount
        ? fm({ id: LOCALIZED_TEXT.totalRefund })
        : fm({ id: LOCALIZED_TEXT.partialRefund });
  } else if (isDiscount) {
    status = fm({ id: LOCALIZED_TEXT.coupon });
  } else {
    status = getOrderTaskStatusFriendlyName(orderTransaction || parentOrderTask, fm);
  }

  return transactionDatetime && amount ? (
    <Styled.ChargesRow>
      <td>
        {loading ? (
          <Skeleton variant="rectangular" height={30} />
        ) : (
          <Styled.ChargesDescription>{splitDescription}</Styled.ChargesDescription>
        )}
      </td>
      <td>
        {loading ? (
          <Skeleton variant="rectangular" height={30} />
        ) : (
          <Text variant="body2">{format(new Date(transactionDatetime), 'MMMM do, yyyy')}</Text>
        )}
      </td>
      <td>{loading ? <Skeleton variant="rectangular" height={30} /> : <Text variant="body2">{status}</Text>}</td>
      <td>
        {loading ? (
          <Skeleton variant="rectangular" height={30} />
        ) : (
          <Text variant="body2">
            {isRefund || isDiscount ? '-$' : '$'}
            {amount.replace('-', '')}
          </Text>
        )}
      </td>
    </Styled.ChargesRow>
  ) : null;
};

ChargesRow.propTypes = {
  loading: PropTypes.bool,
  transaction: PropTypes.shape({
    amount: PropTypes.string,
    orderItemUuid: PropTypes.string,
    transactionDatetime: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  orderTasks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  parentOrderTask: PropTypes.shape({}),
  parentTransaction: PropTypes.shape({
    amount: PropTypes.string,
  }),
  isRefund: PropTypes.bool,
  isDiscount: PropTypes.bool,
};

export default ChargesRow;
